import { Component, ElementRef, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';

/**
 * Generated class for the RoutingnalogbankPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
declare var google;
declare var RichMarker;
declare var RichMarkerPosition;

@Component({
  selector: 'page-routingnalogbank',
  templateUrl: 'routingnalogbank.html',
})
export class RoutingnalogbankPage {
  @ViewChild('mapFull') mapElement: ElementRef;
  RouteId = ''
  Pois = []
  _pts = []

  Map: any
  PathLines = []
  draw = []

  traekti: boolean = false;
  avtopati: boolean = false;
  patarini: boolean = false;

  tipRuta: boolean = false;
  cntdata = 0;
  pinMarker: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
    this.RouteId = this.navParams.get('rid')
    this.Pois = this.navParams.get('pois')
    // console.log(this.Pois, 'Pois')
    this._pts.push({ id: this.gn.centralnabaza[0].id, ppid: this.gn.centralnabaza[0].id, type: 1, long: this.gn.centralnabaza[0].lon, lat: this.gn.centralnabaza[0].lat, name: this.gn.centralnabaza[0].name })

    for (var i = 0; i < this.Pois.length; i++) {
      if (this.Pois[i].name != 'Централна База - Скопје ул. Водњанска бр. 1') {
        this._pts.push({ id: this.Pois[i].id, ppid: this.Pois[i].id, type: this.Pois[i].type, long: this.Pois[i].long, lat: this.Pois[i].lat, name: this.Pois[i].name })
      }
      this.Pois[i].marker = null
    }
    this._pts.push({ id: this.gn.centralnabaza[0].id, ppid: this.gn.centralnabaza[0].id, type: 1, long: this.gn.centralnabaza[0].lon, lat: this.gn.centralnabaza[0].lat, name: this.gn.centralnabaza[0].name })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RoutingnalogbankPage');
    this.initMap()
  }

  initMap() {
    var mapOptions = {
      zoom: 15,
      maxZoom: 20,
      minZoom: 6,
    }
    this.Map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.gn._Post('/api/gn/insertgoogleuse', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), path: this.gn.crypt('edit route') }, function () {
    })
    this.Map.setCenter({ lat: 41.998802, lng: 21.427379 })
    this.drawMarkers()
  }

  drawMarkers() {

    this.draw.push({ lon: this.gn.centralnabaza[0].lon, lat: this.gn.centralnabaza[0].lat })
    var bounds1 = new google.maps.LatLngBounds();

    for (var i = 0; i < this._pts.length; i++) {
      bounds1.extend({ lat: parseFloat(this._pts[i].lat), lng: parseFloat(this._pts[i].long) });

      if (this._pts[i].marker != null) {
        this._pts[i].marker.setMap(null)
        this._pts[i].marker = null
      }

      if (parseFloat(this._pts[i].long) != 0 && parseFloat(this._pts[i].lat) != 0) {
        var img = 'assets/imgs/newpin-blue2.png'
        if (i == 0) {
          img = 'assets/imgs/newpin-red-green1.png'
          var el = document.createElement("div");
          el.className = 'div-marker-rec'
          el.innerHTML = '<img src="' + img + '" style="width:43px; height:43px; position:relative; top:-11px;"/>'
          this.pinMarker = new RichMarker({
            position: new google.maps.LatLng(parseFloat(this._pts[i].lat), parseFloat(this._pts[i].long)),
            map: this.Map,
            draggable: false,
            content: el.outerHTML,
            anchor: RichMarkerPosition.MIDDLE
          });
        } else {
          if (i < this._pts.length - 1) {
            var markerIcon = {
              url: img,
              scaledSize: new google.maps.Size(38, 43),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(13, 43),
              labelOrigin: new google.maps.Point(13, 13)
            };
            /*done*/this._pts[i].marker = new google.maps.Marker({
              position: { lat: parseFloat(this._pts[i].lat), lng: parseFloat(this._pts[i].long) },
              map: this.Map,
              icon: markerIcon, //'assets/imgs/pin-blue.png',
              label: {
                text: (parseInt(i + '') + 1) + '',
                color: "#000",
                fontSize: "14px",
                fontWeight: "bold",
              },
            });
          }
        }
      }

      if (this._pts[i].type + '' != '1') {
        var _that = this
        this.gn._Post('/api/gn/getonezone', { zid: this.gn.crypt(this._pts[i].ppid) }, function (_data) {
          // console.log(_data[0])
          for (var i = 0; i < _data.length; i++) {
            // console.log()
            var _pois = _data[i].pois.split(",")
            var pp = []
            for (var j = 0; j < _pois.length; j++) {
              var tmp = _pois[j].split(' ')
              pp.push({ lon: parseFloat(tmp[1]), lat: parseFloat(tmp[0]) })
            }
            _that.drawPoly(_data[i].color, pp, _data[i].name, _that._pts[i].id)
          }
        })
      }
      var proba = { lon: parseFloat(this._pts[i].long), lat: parseFloat(this._pts[i].lat) }

      if (parseFloat(this._pts[i].long) != 0 && parseFloat(this._pts[i].lat) != 0) {
        if (this._pts[i].name != 'Централна База - Скопје ул. Водњанска бр. 1')
          this.draw.push(proba)
      }

      if (i == this._pts.length - 1) {
        this.draw.push({ lon: this.gn.centralnabaza[0].lon, lat: this.gn.centralnabaza[0].lat })
      }
    }
    this.Map.fitBounds(bounds1);

    var _optimum = 'fastest'
    if (this.tipRuta == true) { _optimum = 'shortest' }

    var _TollRoad = "no"; if (this.patarini == true) { _TollRoad = "yes" }
    var _Highways = "no"; if (this.avtopati == true) { _Highways = "yes" }
    var _Ferry = "no"; if (this.traekti == true) { _Ferry = "yes" }
    var _that = this

    //newwww
    var l = 49
    var _limitcnt = Math.ceil((this.draw.length / l))
    var _that = this
    var _pp = []
    //var bounds1 = new google.maps.LatLngBounds();
    this.cntdata = 0;

    setTimeout(function () {
      for (var c = 0; c < _limitcnt; c++) {
        (function (ind) {
          var _ptssub = _that.draw.slice(ind * l, ind * l + l);
          var _ptscheck = _that.draw.slice(ind * l + l, ind * l + l + 1);
          if (_ptscheck[0] != undefined) {
            _ptssub.push({ lon: _ptscheck[0].lon, lat: _ptscheck[0].lat })
          }
          //debugger
          setTimeout(function () {
            console.log('_ptssub.length ' + _ptssub.length)
            _that.gn.Socket.emit({ routeby: _that.gn.clientsettings.routeby, end: _limitcnt, cid: _that.gn.user.ClientId, uid: _that.gn.user.UserId, points: _ptssub, TollRoad: _TollRoad, Highways: _Highways, Ferry: _Ferry, Type: _optimum, Unit: "k" }, function (_data4) {
              _that.cntdata++;
              for (var i = 0; i < _data4.routes.length; i++) {
                var _route = _data4.routes[i]
                for (var j = 0; j < _route.points.length; j++) {
                  _pp.push({ lat: parseFloat(_route.points[j].lat), lng: parseFloat(_route.points[j].lng) })
                  bounds1.extend({ lat: parseFloat(_route.points[j].lat), lng: parseFloat(_route.points[j].lng) });
                }
              }
              if (parseInt(_that.cntdata + '') == parseInt(_data4.end + '')) {
                if (_data4.time != 0 || _data4.distance != 0) {
                  _that.Map.fitBounds(bounds1);
                  _that.drawLine(_pp)
                }
              }
            }, 'getDirections')

          }, 1500);
        })(c);
      }
    }, 200);
    //newwww

    // this.gn.Socket.emit({ cid: this.gn.user.ClientId, uid: this.gn.user.UserId, points: this.draw, TollRoad: _TollRoad, Highways: _Highways, Ferry: _Ferry, Type: _optimum, Unit: "k" }, function (_data) {
    //   var _pp = []
    //   var bounds = new google.maps.LatLngBounds();
    //   for (var i = 0; i < _data.routes.length; i++) {
    //     var _route = _data.routes[i]
    //     for (var j = 0; j < _route.points.length; j++) {
    //       _pp.push({ lat: parseFloat(_route.points[j].lat), lng: parseFloat(_route.points[j].lng) })
    //       bounds.extend({ lat: parseFloat(_route.points[j].lat), lng: parseFloat(_route.points[j].lng) });
    //     }
    //   }
    //   _that.Map.fitBounds(bounds);
    //   _that.drawLine(_pp)
    // }, 'getDirections')







    // console.log(this.draw, 'daj mi ppda vidam')
    // this.drawLine(this.draw)


    // bounds.extend({ lat: parseFloat(this.Pois[i].lat), lng: parseFloat(this.Pois[i].long) });
  }


  drawPoly(_color, _pois, _title, _id) {
    // console.log('drawPoly', _color, _pois, _title)
    var _pp = []
    for (var i = 0; i < _pois.length; i++) {
      _pp.push({ lat: _pois[i].lat, lng: _pois[i].lon })
    }
    var _poly = new google.maps.Polygon({
      paths: _pp,
      strokeColor: _color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: _color,
      fillOpacity: 0.35,
      id: _id
    });
    // var hasArea = false;
    // for (var j = 0; j < this.Areas.length; j++) {
    //   if (this.Areas[j].id == _id)
    //     hasArea = true;
    // }
    // if (!hasArea) {
    //   alert(888)
    _poly.setMap(this.Map)
    //   this.Areas.push(_poly)
    // }
    // console.log(this.historyMap)

    //alert(this.Areas.length + ' * ' + this.tochkiPoseta.length)
    // _poly.AreaName = _title
    // _poly.AreaId = _zoneid
    // _poly.AreaColor = _color
  }

  drawLine(_points) {
    var _Line = new google.maps.Polyline({
      path: _points,
      strokeColor: '#5075b1',
      strokeOpacity: 1,
      strokeWeight: 4
    });
    _Line.setMap(this.Map)
    this.PathLines.push(_Line)
  }


}



// WEBPACK FOOTER //
// ./src/pages/routing/routebank/reportorderbank/routingnalogbank.ts